import { mainData } from "./model/data";

import { productCategories } from "./model/categoryData";

import { markupCategory } from "./view/categoryMarkup";


import { generateMarkup } from "./view/generateMarkup";

import { materialFilter } from "./model/filters";

import { initComponent } from "./components/initComponent";

const productRange = document.querySelector('meta[name="material"]').content;

const productData = materialFilter(productRange, mainData);

const categoryContainer = document.querySelector(".category__wrapper");

const categorData = productCategories(productData);

initComponent()

generateMarkup(categoryContainer, categorData, markupCategory);
